/**
 * Prevent Swiper from breaking native video fullscreen on mobile browsers.
 *
 * Swiper applies CSS transforms to its wrapper, which causes Android Chrome to
 * exit fullscreen immediately. Lock the slider while a video is fullscreen.
 */
const bindSwiperVideoFullscreen = (swiper) => {
	const container = swiper.el;
	const videos = container.querySelectorAll("video");

	if (!videos.length) {
		return;
	}

	const getFullscreenElement = () =>
		document.fullscreenElement || document.webkitFullscreenElement;

	const findActiveVideo = () => {
		const fullscreenElement = getFullscreenElement();

		if (!fullscreenElement || !container.contains(fullscreenElement)) {
			return null;
		}

		return fullscreenElement.closest("video") || fullscreenElement;
	};

	const setLocked = (locked) => {
		container.classList.toggle("is-video-fullscreen", locked);

		if (locked) {
			swiper.allowTouchMove = false;
			swiper.disable();
			return;
		}

		swiper.enable();
		swiper.allowTouchMove = true;
	};

	const onFullscreenChange = () => {
		setLocked(Boolean(findActiveVideo()));
	};

	videos.forEach((video) => {
		if (!video.hasAttribute("playsinline")) {
			video.setAttribute("playsinline", "");
		}

		// iOS Safari pseudo-fullscreen events.
		video.addEventListener("webkitbeginfullscreen", () => setLocked(true));
		video.addEventListener("webkitendfullscreen", () => setLocked(false));
	});

	document.addEventListener("fullscreenchange", onFullscreenChange);
	document.addEventListener("webkitfullscreenchange", onFullscreenChange);
};

export default bindSwiperVideoFullscreen;
